import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeColor, setThemeColor] = useState("primary"); // default primary theme

  const changeTheme = (color) => setThemeColor(color);

  useEffect(() => {
    // Set CSS variables based on theme color
    const root = document.documentElement;
    
    if (themeColor === "#181818") {
      // Dark theme
      root.style.setProperty('--card-bg-color', '#2d2d2d');
      root.style.setProperty('--card-border-color', '#404040');
      root.style.setProperty('--text-color', '#ffffff');
      root.style.setProperty('--body-bg-color', '#181818');
      root.style.setProperty('--text-muted-color', '#a0a0a0');
    } else {
      // Default/light theme
      root.style.setProperty('--card-bg-color', '#ffffff');
      root.style.setProperty('--card-border-color', '#e9ecef');
      root.style.setProperty('--text-color', '#333333');
      root.style.setProperty('--body-bg-color', '#ffffff');
      root.style.setProperty('--text-muted-color', '#878a99');
    }
  }, [themeColor]);

  return (
    <ThemeContext.Provider value={{ themeColor, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};